import { useEffect } from "react";
import { LayoutProps, TErrorFallback } from "@ts/common-types";
import * as Sentry from "@sentry/react";
import ErrorHandler from "./ErrorHandler";
import ChartsErrorComponents from "./ChartsErrorComponents";

const ErrorFallback: React.FC<TErrorFallback> = ({
    error
}) => {
    useEffect(() => {
        console.error(`[DataChartErrorHandler] ${error}`);
        Sentry.captureException(error);
    }, [error]);

    return <ChartsErrorComponents />;
};

const DataChartErrorHandler: React.FC<LayoutProps> = (props) => {
    return (
        <>
            <ErrorHandler FallbackComponent={ErrorFallback}>
                {props.children}
            </ErrorHandler>
        </>
    );
};

export default DataChartErrorHandler;
